import {cardTitle, defaultFont} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import buttonGroupStyle from "assets/jss/material-dashboard-pro-react/buttonGroupStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import wizardStyle from "../components/wizardStyle.jsx";

const pdpeStyle = {
  ...wizardStyle,
  ...customCheckboxRadioSwitch,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    },
    textTransform: "capitalize"
  },
  ...buttonStyle,
  ...buttonGroupStyle,
  swipeableViews: {
    "& .react-swipeable-view-container > div > div": {
      height: "100%",
    }
  },
  questoes: {
    margin: "0 15px",
    display: "flex",
    flexDirection: "column",
    height: "100%",

    "& h3": {
      marginTop: 0
    }
  },
  questaoHeader: {
    display: "block",
    marginBottom: "10px",
    flex: 1,
    "&>span": {
      display: "block"
    },
    "&:hover>span": {
      opacity: "1"
    }
  },
  buttonAnterior: {
    marginRight: "10px",
  },
  buttonSeguinte: {
    marginLeft: "auto",
  },
  actions: {
    marginLeft: "auto",

    "& >button": {
      marginLeft: "10px"
    }
  },
  nivelButton: {
    fontSize: "13px",
    textTransform: "none",
    width: "100%",
    display: "block",
    whiteSpace: "normal",
    textAlign: "left",
    marginBottom: 15,
    color: "#0c0c0c",
    "&:hover": {
      color: "#424242"
    }
  },
  nivelButtonActive: {
    fontSize: "13px",
    textTransform: "none",
    display: "block",
    width: "100%",
    whiteSpace: "normal",
    textAlign: "left",
    marginBottom: 15
  },
  infoModalContainer: {
    textAlign: "left",
    marginTop: "25px"
  },
  openInfoButton: {
    float: "right",
    fontSize: "20px",
    opacity: "0.25",
    color: "#a9a9a9",
    transition: "all 0.1s linear",
    "&:hover": {
      cursor: "pointer",
      color: "#3b3b3b",
    }
  },
  planoContainer: {
    "& h5": {
      marginTop: 30
    }
  },
  planoTabela: {
    borderCollapse: "collapse",
    width: "100%",
    margin: "25px 0",
    "& th": {
      ...defaultFont,
      color: "black",
      fontWeight: 400,
      fontSize: "0.8em",
      padding: "10px",
      textTransform: "uppercase",
      backgroundColor: "lightgrey",
      border: "1px solid lightgrey"
    },
    "& td": {
      padding: "10px",
      "&>div": {
        width: "100%",
        marginBottom: "-1px"
      },
      border: "1px solid lightgrey"
    },
    "& tr:nth-child(even)": {
      backgroundColor: "#f9f9f9"
    }
  },
  objetivosAccordionSummary: {
    "& .MuiExpansionPanelSummary-content": {
      display: "flex",
      width: 0,
      "& h4:first-child": {
        display: "flex",
        flex: 1,
        width: 0,
        alignItems: "center"
      },
      "& .title": {
        flex: 1,
      },
      "& .label_obrigatorio": {
        backgroundColor: "rgb(245, 118, 13)",
        color: "white",
        padding: "0 5px",
        textTransform: "uppercase",
        borderRadius: 5,
        fontSize: "80%",
        marginLeft: 8,
        display: "inline-block"
      }
    },
    "& span": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }
  },
  objetivosAccordionExpansionPanel: {},
  navegacao: {
    display: "flex",
  }
};

export default pdpeStyle;

